/** CoStar.Api.EnterpriseSub2.Migrated.Reports.SearchMode */
export var SearchMode;
(function (SearchMode) {
    SearchMode[SearchMode["ForLease"] = 0] = "ForLease";
    SearchMode[SearchMode["ForSale"] = 1] = "ForSale";
    SearchMode[SearchMode["LeaseDeal"] = 2] = "LeaseDeal";
    SearchMode[SearchMode["SaleComp"] = 3] = "SaleComp";
    SearchMode[SearchMode["Property"] = 4] = "Property";
    SearchMode[SearchMode["Tenant"] = 5] = "Tenant";
    SearchMode[SearchMode["ShoppingCenter"] = 6] = "ShoppingCenter";
})(SearchMode || (SearchMode = {}));
/** CoStar.Api.EnterpriseSub2.Migrated.Reports.ReportType */
export var ReportType;
(function (ReportType) {
    ReportType[ReportType["PropertySummary"] = 0] = "PropertySummary";
    ReportType[ReportType["TenantReport"] = 1] = "TenantReport";
    ReportType[ReportType["SaleCompReport"] = 2] = "SaleCompReport";
    ReportType[ReportType["MultipleListingReport"] = 3] = "MultipleListingReport";
    ReportType[ReportType["TenantsThatMeetCriteria"] = 4] = "TenantsThatMeetCriteria";
    ReportType[ReportType["SaleCompThatMeetCriteria"] = 5] = "SaleCompThatMeetCriteria";
    ReportType[ReportType["PropertySummaryWithoutContacts"] = 6] = "PropertySummaryWithoutContacts";
    ReportType[ReportType["LeaseCompReport"] = 7] = "LeaseCompReport";
    ReportType[ReportType["LeaseCompsThatMeetCriteria"] = 8] = "LeaseCompsThatMeetCriteria";
    ReportType[ReportType["ClassicOnePage"] = 9] = "ClassicOnePage";
    ReportType[ReportType["MapOverview"] = 10] = "MapOverview";
    ReportType[ReportType["ForSaleOnePage"] = 11] = "ForSaleOnePage";
    ReportType[ReportType["ClassicOnePageWithoutContacts"] = 12] = "ClassicOnePageWithoutContacts";
    ReportType[ReportType["Unknown"] = -1] = "Unknown";
})(ReportType || (ReportType = {}));
